export const STORAGE_KEY = `auth-tokens-${process.env.NODE_ENV}`
